import { render, staticRenderFns } from "./QuickTask.vue?vue&type=template&id=1c01dfbf&scoped=true&"
import script from "./QuickTask.vue?vue&type=script&lang=js&"
export * from "./QuickTask.vue?vue&type=script&lang=js&"
import style0 from "./QuickTask.vue?vue&type=style&index=0&id=1c01dfbf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c01dfbf",
  null
  
)

export default component.exports